import { generarInfoTabla } from "..";
import {
  isCancelacionType,
  requiresCancelacionSubreason,
} from "shared/utils/endosoTypes";
export const rulesByFiveSeven = async (
  data,
  oldData,
  dataSend,
  setMessage,
  setShowMessage,
  formDta,
  endoso,
  setInfoTable,
  setShowButtons,
  showButtons
) => {
  const isCancellation = isCancelacionType(data.tipend);
  const shouldRequireCancelacionSubreason = requiresCancelacionSubreason(
    data.tipend
  );

  const guardar = async () => {
    const body = {
      nivel: formDta.nivel,
      orden: 1,
      solicitud: formDta.noSolicitud,
      valor: isCancellation ? dataSend.MOTANU : dataSend.PERPAG,
    };
    const guardaResponse = await endoso.saveEndoso(body);
    if (guardaResponse.data?.codigo === 1) {
      setInfoTable(generarInfoTabla(oldData, dataSend, data.tipend, formDta));
      setShowButtons({ ...showButtons, infoTable: true, domicilio: false });
      return true;
    }
    setMessage({
      text:
        guardaResponse.data?.mensaje ||
        "SU SOLICITUD NO HA PODIDO SER PROCESADA",
      severity: "warning",
    });
    setShowMessage(true);
    return false;
  };

  if (isCancellation) {
    if (
      dataSend.MOTANU &&
      (!shouldRequireCancelacionSubreason || dataSend.SMOTANU)
    )
      return guardar();
    setMessage({
      text: "Por favor complete los campos requeridos para continuar",
      severity: "warning",
    });
    setShowMessage(true);
    return false;
  }
  return guardar();
};
